import React from 'react';
import { PresentationChart, Users } from '../../../../../../ui/icons/icons';
import { IResultListData } from '../Hooks/UseAssesmentResultList';

interface IResultsStats {
  countCompleted: number;
  countTotal: number;
  calculateAverageTime: () => string;
  resultListData: IResultListData | undefined;
}
export const ResultsStats = (props: IResultsStats) => {
  const { countCompleted, countTotal, calculateAverageTime, resultListData } =
    props;
  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-2'>
      { /* Total Candidates Card */ }
      <div className='bg-white rounded-xl border border-gray-200 shadow-sm'>
        <div className='flex items-center p-1.5'>
          <div className='flex-shrink-0 mr-2'>
            <div className='w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-600/10'>
              <Users className='w-4 h-4 text-emerald-600' />
            </div>
          </div>
          <div className='flex items-center gap-4 md:gap-6 flex-wrap sm:flex-nowrap'>
            <div>
              <span className='block text-[10px] text-gray-500 font-medium leading-tight'>
                Completed
              </span>
              <span className='text-base font-bold text-emerald-600 block leading-tight'>
                { countCompleted }
              </span>
            </div>
            <div className='h-6 w-px bg-gray-200'></div>
            <div>
              <span className='block text-[10px] text-gray-500 font-medium leading-tight'>
                Total
              </span>
              <span className='text-base font-bold text-gray-900 block leading-tight'>
                { countTotal }
              </span>
            </div>
          </div>
        </div>
      </div>

      { /* Average Time Card */ }
      <div className='bg-white rounded-xl border border-gray-200 shadow-sm'>
        <div className='flex items-center p-1.5'>
          <div className='flex-shrink-0 mr-2'>
            <div className='w-8 h-8 flex items-center justify-center rounded-lg bg-blue-600/10'>
              <svg
                  className='w-4 h-4 text-blue-600'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
              >
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
            </div>
          </div>
          <div>
            <span className='block text-[10px] text-gray-500 font-medium leading-tight'>
              Average Time
            </span>
            <span className='text-base font-bold text-blue-600 block leading-tight'>
              { calculateAverageTime() }
            </span>
          </div>
        </div>
      </div>

      { /* Highest Score Card */ }
      <div className='bg-white rounded-xl border border-gray-200 shadow-sm'>
        <div className='flex items-center p-1.5'>
          <div className='flex-shrink-0 mr-2'>
            <div className='w-8 h-8 flex items-center justify-center rounded-lg bg-purple-600/10'>
              <PresentationChart className='w-4 h-4 text-purple-600' />
            </div>
          </div>
          <div>
            <span className='block text-[10px] text-gray-500 font-medium leading-tight'>
              Highest Score
            </span>
            <span className='text-base font-bold text-purple-600 block leading-tight'>
              { (() => {
                const score = resultListData?.highestScore;
                return isFinite(score as number)
                  ? Math.min(score as number, 100)
                  : 0;
              })() }
              %
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
